import { render, staticRenderFns } from "./ticket-intro.vue?vue&type=template&id=6722bd20"
import script from "./ticket-intro.vue?vue&type=script&lang=ts"
export * from "./ticket-intro.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6722bd20')) {
      api.createRecord('6722bd20', component.options)
    } else {
      api.reload('6722bd20', component.options)
    }
    module.hot.accept("./ticket-intro.vue?vue&type=template&id=6722bd20", function () {
      api.rerender('6722bd20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ticket/ticket-intro.vue"
export default component.exports